var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { XForm } from "@bluelibs/x-ui-admin";
import { Service } from "@bluelibs/core";
import * as Ant from "antd";
import { UsersCollection, CompaniesCollection, ExternalsCollection, BankAccountsCollection, } from "@bundles/UIAppBundle/collections";
import { UserRole } from "@root/api.types";
let TransactionListFiltersForm = class TransactionListFiltersForm extends XForm {
    build(userRoles) {
        const { UIComponents } = this;
        const { t } = this.i18n;
        this.add([
            {
                id: "createdAt",
                label: t("management.transactions.fields.createdAt"),
                name: ["createdAt"],
                tooltip: t("management.transactions.fields.createdAt_description"),
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(Ant.DatePicker.RangePicker, {}, void 0) }), void 0)),
            },
            {
                id: "updatedAt",
                label: t("management.transactions.fields.updatedAt"),
                name: ["updatedAt"],
                tooltip: t("management.transactions.fields.updatedAt_description"),
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(Ant.DatePicker.RangePicker, {}, void 0) }), void 0)),
            },
            {
                id: "type",
                label: t("management.transactions.fields.type"),
                name: ["type"],
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(Ant.Input, {}, void 0) }), void 0)),
            },
            {
                id: "transactionDate",
                label: t("management.transactions.fields.transactionDate"),
                name: ["transactionDate"],
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(Ant.DatePicker.RangePicker, {}, void 0) }), void 0)),
            },
            {
                id: "transactionIdentifier",
                label: t("management.transactions.fields.transactionIdentifier"),
                name: ["transactionIdentifier"],
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(Ant.Input, {}, void 0) }), void 0)),
            },
            {
                id: "dueDate",
                label: t("management.transactions.fields.dueDate"),
                name: ["dueDate"],
                tooltip: t("management.transactions.fields.dueDate_description"),
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(Ant.DatePicker.RangePicker, {}, void 0) }), void 0)),
            },
            {
                id: "amount",
                label: t("management.transactions.fields.amount"),
                name: ["amount"],
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(Ant.Slider, { range: true, step: 10, min: 0, max: 100000 }, void 0) }), void 0)),
            },
            {
                id: "isCompleted",
                label: t("management.transactions.fields.isCompleted"),
                name: ["isCompleted"],
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsxs(Ant.Radio.Group, { children: [_jsx(Ant.Radio, Object.assign({ value: false }, { children: "No" }), 0), _jsx(Ant.Radio, Object.assign({ value: true }, { children: "Yes" }), 1)] }, void 0) }), void 0)),
            },
            {
                id: "completeDate",
                label: t("management.transactions.fields.completeDate"),
                name: ["completeDate"],
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(Ant.DatePicker.RangePicker, {}, void 0) }), void 0)),
            },
            {
                id: "notes",
                label: t("management.transactions.fields.notes"),
                name: ["notes"],
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(Ant.Input, {}, void 0) }), void 0)),
            },
            {
                id: "companyId",
                label: t("management.transactions.fields.company"),
                name: ["companyId"],
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(UIComponents.RemoteSelect, { collectionClass: CompaniesCollection, field: "name", placeholder: "Please select an option", mode: "multiple" }, void 0) }), void 0)),
            },
            {
                id: "externalId",
                label: t("management.transactions.fields.external"),
                name: ["externalId"],
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(UIComponents.RemoteSelect, { collectionClass: ExternalsCollection, field: "name", placeholder: "Please select an option", mode: "multiple" }, void 0) }), void 0)),
            },
            {
                id: "sourceBankAccountId",
                label: t("management.transactions.fields.sourceBankAccount"),
                name: ["sourceBankAccountId"],
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(UIComponents.RemoteSelect, { collectionClass: BankAccountsCollection, field: "accountNumber", placeholder: "Please select an option", mode: "multiple" }, void 0) }), void 0)),
            },
            {
                id: "destinationBankAccountId",
                label: t("management.transactions.fields.destinationBankAccount"),
                name: ["destinationBankAccountId"],
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(UIComponents.RemoteSelect, { collectionClass: BankAccountsCollection, field: "accountNumber", placeholder: "Please select an option", mode: "multiple" }, void 0) }), void 0)),
            },
            ...(userRoles.includes(UserRole.ADMIN)
                ? [
                    {
                        id: "createdById",
                        label: t("management.transactions.fields.createdBy"),
                        name: ["createdById"],
                        tooltip: t("management.transactions.fields.createdBy_description"),
                        render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(UIComponents.RemoteSelect, { collectionClass: UsersCollection, field: "fullName", placeholder: "Please select an option", mode: "multiple" }, void 0) }), void 0)),
                    },
                    {
                        id: "updatedById",
                        label: t("management.transactions.fields.updatedBy"),
                        name: ["updatedById"],
                        tooltip: t("management.transactions.fields.updatedBy_description"),
                        render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(UIComponents.RemoteSelect, { collectionClass: UsersCollection, field: "fullName", placeholder: "Please select an option", mode: "multiple" }, void 0) }), void 0)),
                    },
                ]
                : []),
        ]);
    }
};
TransactionListFiltersForm = __decorate([
    Service({ transient: true })
], TransactionListFiltersForm);
export { TransactionListFiltersForm };
